import { render, staticRenderFns } from "./RoleTabsDetails.vue?vue&type=template&id=62b7f954"
import script from "./RoleTabsDetails.vue?vue&type=script&lang=js"
export * from "./RoleTabsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports